import { render, staticRenderFns } from "./ScoreReports.vue?vue&type=template&id=5453cc36&scoped=true&"
import script from "./ScoreReports.vue?vue&type=script&lang=js&"
export * from "./ScoreReports.vue?vue&type=script&lang=js&"
import style0 from "./ScoreReports.vue?vue&type=style&index=0&id=5453cc36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5453cc36",
  null
  
)

export default component.exports